export default "__VITE_ASSET__EZg060$g__"